import { zzsValue, zzsStatus } from '@tencent/tencent-doc-report';
import { Reporter007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import config, { EnterPriseType } from '@src/slide/infrastructure/module/dependent/config/tob/enterprise-config';

let defaultDimensions: string[] = [];
/**
 * @deprecated
 * ！非必要切勿使用！
 */
export const setReportContext = (dimensions: string[]) => {
    defaultDimensions = dimensions;
};

/**
 * @deprecated
 * ！非必要切勿使用！
 */
export const clearReportContext = () => {
    defaultDimensions = [];
};

const mergeDimensions = (dimensions: string[] = []) => {
    /** NOTE: 意味着 defaultDimensions 字段是不固定的，无奈之举 */
    const res = [...dimensions, ...defaultDimensions];
    if (res.length === 0) return undefined;

    return res;
};

export const valueReport007 = (attrid: string, value: number, dimensions?: string[]): void  => {
    if (ENV.IS_RELEASE && !ENV.IS_TEST) {
        zzsValue({
            attrid, // 自定义属性名，同品类下不重复即可
            value, // 具体数值
            dimensions: mergeDimensions(dimensions),
            project: config.supportEnterprise(EnterPriseType.ALL)
                ? Reporter007.SLIDE_ENTERPRISE : Reporter007.SLIDE_V3,
        });
    }
};

export const statusReport007 = (attrid: string, status: number, errmsg = '', dimensions?: string[]): void => {
    if (ENV.IS_RELEASE && !ENV.IS_TEST) {
        zzsStatus({
            attrid, // 自定义属性名，同品类下不重复即可
            status,
            errmsg,
            dimensions: mergeDimensions(dimensions),
            project: config.supportEnterprise(EnterPriseType.ALL)
                ? Reporter007.SLIDE_ENTERPRISE : Reporter007.SLIDE_V3,
        });
    }
};
